import React from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Container, Typography} from '@material-ui/core';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { useDispatch } from 'react-redux';
import { DeleteItem } from '../../redux/actions/item/ItemAction';

const useModalStyles = makeStyles((theme) => ({

    fontStyle :{fontWeight:'bold', fontFamily:'Times New Roman' },
    spaceStyle:{display:'flex', justifyContent:'space-between'},
    centerStyle:{textAlign:'center'},
    imageStyle:{width:"400px", height:"400px", float:"left"},
    contentStyle:{float:"left",  width:"450px"},

  }));

 

const DialogContent = withStyles((theme) => ({
    root: {
      padding: theme.spacing(2),
    },
  }))(MuiDialogContent);
 
  const DialogActions = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(1),
    },
  }))(MuiDialogActions); 


export const DeleteConfirm = (props) => {
    const classes = useModalStyles();
    const disaptch = useDispatch();
    const{open, setOpen, setParent, id} = props;

    function handleClose(){
        setOpen(false)
    }

    function handleDelete(){
        disaptch(DeleteItem(id))
        setParent(false)
    }


    return (
        <div>
        <Dialog fullWidth maxWidth="sm" onClose={handleClose} 
                aria-labelledby="customized-dialog-title" open={open}>

            <DialogActions style={{justifyContent:"center"}}>
                <Typography align="center">
                    Vous êtes certains de vouloir supprimer ce produit ?
                </Typography>
            </DialogActions>

            <DialogContent>
                <Container maxWidth="lg" className={classes.spaceStyle}>
                        <Button  color="secondary" 
                                onClick={()=> handleDelete()}
                                variant="contained">
                            Oui, continuer
                        </Button>
                        <Button onClick={handleClose} color="secondary" variant="outlined">
                            Non, annuler
                        </Button>
                </Container>
            </DialogContent>

        </Dialog>
      </div>
    )
}
